import { render, staticRenderFns } from "./comprehensiveResults.vue?vue&type=template&id=1500254a&scoped=true&"
import script from "./comprehensiveResults.vue?vue&type=script&lang=js&"
export * from "./comprehensiveResults.vue?vue&type=script&lang=js&"
import style0 from "./comprehensiveResults.vue?vue&type=style&index=0&id=1500254a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1500254a",
  null
  
)

export default component.exports